import { env } from "~/env";

/**
 * Check if the pricing feature is enabled (server-side)
 * Reads from ENABLE_PRICING environment variable
 */
export function isPricingEnabled(): boolean {
  return env.ENABLE_PRICING === "true";
}

/**
 * Check if the pricing feature is enabled (client-side)
 * Uses NEXT_PUBLIC_ENABLE_PRICING environment variable
 */
export function isPricingEnabledClient(): boolean {
  return env.NEXT_PUBLIC_ENABLE_PRICING === "true";
}
